<template>
    <div>
        <div class="area-top-bar">
                <div class="topbar">
                    <img src="@/assets/bg/regis_pic_bg@2x.png" class="img-fluid">
                </div>
                <div v-if="isShowLogo" class="wrapper-logo">
                    <div class="logo-left">
                        <img :src="$store.getters.getLogoBioderma" class="img-fluid">
                    </div>
                    <div class="logo-right">
                        <img :src="$store.getters.getLogoNao" class="img-fluid">
                    </div>
                </div>
        </div> 
    </div>
</template>
<script>
/**
 * @event switchLang
 * @event logout
 * @property {object} lbl (require)
 * @property {string} activeTab (optional)
 * @property {object} profile (require)
 * @property {boolean} isLogin (require)
 * @property {ModalController} modalController (optional)
 */
export default {
    name: 'top-bar',// <top-bar>
    props: {
        lbl: Object,
        activeTab: String,
        profile: Object,
        isLogin: Boolean,
        modalController: Object,
        isShowLogo: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            confirmModal: null,
        };
    },
    created: function () {
        // console.log(this.profile);
        if (this.modalController != null) {
            this.confirmModal = this.modalController.confirmModal;
        }
    },
    methods: {
        initial: function() {
        },

        switchLang: function(locale) {
            this.$emit('switchLang', locale);
        },

        logout: function() {
            this.modalController.confirmModal.clearText()
                    .setTitle("Logout?")
                    .setMsg("You need logout?")
                    .setBtnOk("Logout")
                    .setBtnCancel("No")
                    .show();
            this.confirmModal.onClickOk(() => {
                this.$emit('logout');
            });
        },

        goto(page) {
            this.$router.push('/' + page);
        }
    },
}
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "./TopBarImage.scss";
</style>
